//used in HOOKAH STORE
export const DefaultCategory = ``
